import api from './api';

const adminCommandService = {
  manualSubscription: async (botId, contactId, days) => {
    const response = await api.post(`/bots/${botId}/admin-commands/manual-subscription`, {
      contact_id: contactId,
      days,
    });
    return response.data;
  },

  removeUser: async (botId, contactId) => {
    const response = await api.post(`/bots/${botId}/admin-commands/remove-user`, {
      contact_id: contactId,
    });
    return response.data;
  },

  refundUser: async (botId, contactId) => {
    const response = await api.post(`/bots/${botId}/admin-commands/refund`, {
      contact_id: contactId,
    });
    return response.data;
  },
};

export default adminCommandService;
